// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function s(prim) {
  return prim;
}

function mute(s) {
  if (s === "DF") {
    return "";
  } else {
    return s;
  }
}

function CompPilots$PilotRow(Props) {
  var pilot = Props.pilot;
  return React.createElement("tr", undefined, React.createElement("td", {
                  className: "td-pid"
                }, pilot.pilotId), React.createElement("td", undefined, pilot.pilotName), Belt_Array.mapWithIndex(pilot.pilotStatus, (function (i, status) {
                    return React.createElement("td", {
                                key: String(i)
                              }, mute(status));
                  })));
}

var PilotRow = {
  mute: mute,
  make: CompPilots$PilotRow
};

function CompPilots(Props) {
  var tasks = Props.tasks;
  var pilots = Props.pilots;
  var xs = Belt_Array.map(pilots, (function (pilot) {
          return React.createElement(CompPilots$PilotRow, {
                      pilot: pilot,
                      key: pilot.pilotId
                    });
        }));
  return React.createElement(React.Fragment, undefined, React.createElement("table", {
                  className: "table is-bordered is-striped"
                }, React.createElement("thead", undefined, React.createElement("tr", undefined, React.createElement("th", {
                              className: "th-pid"
                            }, "Id"), React.createElement("th", undefined, "Name"), Belt_Array.mapWithIndex(tasks, (function (i, task) {
                                return React.createElement("th", {
                                            key: String(i)
                                          }, task.taskName);
                              })))), React.createElement("tbody", undefined, xs)));
}

var make = CompPilots;

export {
  s ,
  PilotRow ,
  make ,
  
}
/* react Not a pure module */
